if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            this.cart.renderContents(response);
            if (this.closest('.quick-add-modal')) {
              document.dispatchEvent(new CustomEvent('quick-add:close'));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* === Staffel: groessenbewusstes Kachelbild (Preview-Fix) ===
   Loest: Staffel-Kachelbild (2x/3x) aendert sich nicht beim Groessenwechsel (750/350/300 g).
   Ursache: stf-js-1.liquid waehlt das Kachelbild via packImageFor(flavor) (nur Sorte).
   FINALE Umsetzung gehoert nach stf-js-1.liquid (img-Zeile in renderTiers + flavorSizeImg-Map).
   Hier als additiver Hook auf das stf:render-Event, nur fuer das Preview-Theme.
   HINWEIS: Die Haupt-GALERIE ist NICHT mehr hier - die loest der native
   Alt-Marker-Filter in main-product--default.liquid (Bilder als
   '#Geschmacksrichtungen_<Sorte> / <Groesse>' getaggt). */
(function () {
  function isSizeVal(v) { return /\d+\s*(g|kg|ml|l|kapseln?|kaps|tabletten?|tabs|stk|stück)\b/i.test(v); }
  function optsOf(p) {
    return (p.options_with_values || []).filter(function (o) {
      return !((o.name === 'Title' || o.name === 'Titel') && (o.values || []).length === 1 && o.values[0] === 'Default Title');
    });
  }
  function flavorPos(p) { var o = optsOf(p), a = []; o.forEach(function (x) { if (!x.values.some(isSizeVal)) a.push(x.position - 1); }); return a; }
  function sizePos(p) { var o = optsOf(p); var s = o.find(function (x) { return x.values.some(isSizeVal); }); return s ? s.position - 1 : -1; }
  function buildMap(root) {
    var el = root.querySelector('[data-stf-routines]'); if (!el) return null;
    var routines; try { routines = JSON.parse(el.textContent); } catch (e) { return null; }
    var m = {};
    routines.forEach(function (rt) {
      var p = rt.product, fps = flavorPos(p), sp = sizePos(p); if (!fps.length || sp < 0) return;
      (p.variants || []).forEach(function (v) {
        var fl = v.options[fps[0]], sv = v.options[sp]; var im = v.var_image || v.image;
        var k = fl + '|' + sv; if (fl != null && sv != null && im && !m[k]) m[k] = im;
      });
    });
    return m;
  }
  function fileOf(u) { return (u || '').split('?')[0].split('/').pop(); }
  function curFlavor(root) { var e = root.querySelector('[data-stf-flavor-name]'); return e ? e.textContent.trim() : null; }
  function curSize(root) { var b = root.querySelector('.stf-gsize-list button.is-active'); return b ? b.getAttribute('data-size') : null; }
  function apply(root) {
    if (!root.__sizeImgMap) root.__sizeImgMap = buildMap(root);
    var map = root.__sizeImgMap; if (!map) return;
    var fl = curFlavor(root), sz = curSize(root); if (fl == null || sz == null) return;
    var img = map[fl + '|' + sz]; if (!img) return;
    // Staffel-Kacheln: gestapelte Einzelpackbilder (keine eigenen Set-Bilder)
    root.querySelectorAll('.stf-tier .stf-imgwrap img:not(.stf-setimg)').forEach(function (i) {
      if (fileOf(i.getAttribute('src')) !== fileOf(img)) i.setAttribute('src', img);
    });
  }
  document.addEventListener('stf:render', function (e) {
    var root = (e.detail && e.detail.root) || document.querySelector('[data-stf-root]');
    if (root) setTimeout(function () { apply(root); }, 0);
  });
})();

/* === Staffel -> Haupt-Galerie koppeln (Preview-Fix) ===
   Problem: Im Sale ist der Haupt-Varianten-Picker versteckt; der sichtbare
   Staffel-Groessenselektor steuert die Galerie NICHT (und das Setzen der
   Variante wuerde die Staffel zuruecksetzen -> Desync). Loesung: bei jedem
   Staffel-Wechsel (stf:render) die Galerie-Slides fuer die Ziel-Variante per
   Section-Rendering-API nachladen und via Swiper.update() tauschen - OHNE
   Variante/Staffel/Cart anzufassen. Der native Alt-Marker-Filter in
   main-product--default.liquid liefert pro Variante die richtigen Bilder
   (Bilder getaggt als '#Geschmacksrichtungen_<Sorte> / <Groesse>').
   Greift nur auf Produkten mit Staffel-Widget; sonst No-Op. */
(function () {
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function isSizeVal(v) { return /\d+\s*(g|kg|ml|l|kapseln?|kaps|tabletten?|tabs|stk|stück)\b/i.test(v); }
  var cache = {}, busy = false, lastSynced = null;
  function sectionId() { var g = document.querySelector('.product-main-swiper'); var w = g && g.closest('[id^="shopify-section-"]'); return w ? w.id.replace('shopify-section-', '') : null; }
  function handle() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? m[1] : null; }
  function routines() { var el = document.querySelector('[data-stf-routines]'); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function curFlavor() { var e = document.querySelector('[data-stf-flavor-name]'); return e ? norm(e.textContent) : null; }
  function curSize() { var b = document.querySelector('.stf-gsize-list button.is-active'); return b ? norm(b.getAttribute('data-size')) : null; }
  function targetVariantId() {
    var rts = routines(); if (!rts) return null;
    var fl = curFlavor(), sz = curSize(); if (fl == null || sz == null) return null;
    for (var i = 0; i < rts.length; i++) {
      var p = rts[i].product; if (!p) continue;
      var opts = (p.options_with_values || []).filter(function (o) { return !((o.name === 'Title' || o.name === 'Titel') && (o.values || []).length === 1 && o.values[0] === 'Default Title'); });
      var sizeIdx = -1, flavIdx = -1;
      opts.forEach(function (o) { var isSize = (o.values || []).some(isSizeVal); if (isSize) { if (sizeIdx < 0) sizeIdx = o.position - 1; } else if (flavIdx < 0) { flavIdx = o.position - 1; } });
      var vs = p.variants || [];
      for (var j = 0; j < vs.length; j++) {
        var v = vs[j];
        var vf = flavIdx >= 0 ? norm(v.options[flavIdx]) : '';
        var vsz = sizeIdx >= 0 ? norm(v.options[sizeIdx]) : '';
        if (vf === fl && vsz === sz) return v.id;
      }
    }
    return null;
  }
  async function fetchSection(vid) {
    if (cache[vid]) return cache[vid];
    var sid = sectionId(), h = handle(); if (!sid || !h) return null;
    var url = '/products/' + h + '?variant=' + vid + '&section_id=' + encodeURIComponent(sid);
    var txt = await (await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).text();
    cache[vid] = txt; return txt;
  }
  async function syncGallery() {
    if (busy) return;
    var vid = targetVariantId(); if (vid == null) return;
    if (String(vid) === String(lastSynced)) return;
    if (!window.mainProductSlider) return;
    var mainWrap = document.querySelector('.product-main-swiper .swiper-wrapper'); if (!mainWrap) return;
    busy = true;
    try {
      var txt = await fetchSection(vid); if (!txt) { busy = false; return; }
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var newMain = doc.querySelector('.product-main-swiper .swiper-wrapper');
      var newThumb = doc.querySelector('.product-thumbs-swiper .swiper-wrapper');
      if (newMain) {
        mainWrap.innerHTML = newMain.innerHTML;
        var thumbInst = window.mainProductSlider.thumbs && window.mainProductSlider.thumbs.swiper;
        var thumbWrap = thumbInst && thumbInst.el ? thumbInst.el.querySelector('.swiper-wrapper') : null;
        if (newThumb && thumbWrap) thumbWrap.innerHTML = newThumb.innerHTML;
        try { window.mainProductSlider.update(); if (thumbInst) thumbInst.update(); window.mainProductSlider.slideTo(0, 0); } catch (e) {}
        lastSynced = vid;
      }
    } catch (e) {}
    busy = false;
  }
  function initLast() { var inp = document.querySelector('[name=id]'); if (inp && inp.value) lastSynced = inp.value; }
  if (document.readyState !== 'loading') initLast(); else document.addEventListener('DOMContentLoaded', initLast);
  document.addEventListener('stf:render', function () { setTimeout(syncGallery, 60); });
  document.addEventListener('click', function (e) { var t = e.target; if (t && t.closest && t.closest('.stf-gsize-list button')) setTimeout(syncGallery, 150); });
})();
